import { render, staticRenderFns } from "./CurrentBalanceCard.vue?vue&type=template&id=91f5500a"
import script from "./CurrentBalanceCard.vue?vue&type=script&lang=js"
export * from "./CurrentBalanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports